import React, {useCallback, useState} from 'react';
import { Button, Tooltip, Modal, Input, notification } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import {useAppDispatch} from "../../../redux/hooks";
import {PropertyFull} from "../../../types";
import {updateProperty} from "../../../redux/api/documents/propertiesThunks";

export interface EditPropertyActionProps {
    property: PropertyFull;
}

const EditPropertyAction: React.FC<EditPropertyActionProps> = ({ property }) => {
    const dispatch = useAppDispatch();
    const [visible, setVisible] = useState<boolean>(false);
    const [editedText, setEditedText] = useState<string>(property.text);

    const handleSave = useCallback(async () => {
        try {
            await dispatch(
                updateProperty({
                    id: property.id,
                    text: editedText,
                    documentId: property.documentId,
                    propertyTypeId: property.propertyTypeId,
                })
            );
            notification.success({ message: 'Свойство обновлено' });
            setVisible(false);
        } catch (error: any) {
            notification.error({
                message: 'Ошибка при обновлении свойства',
                description: error.message || 'Не удалось обновить свойство.',
            });
        }
    }, [dispatch, property, editedText]);

    const handleCancel = useCallback(() => {
        setVisible(false);
        setEditedText(property.text);
    }, [property.text]);


    return (
        <>
            <Tooltip title="Изменить">
                <Button icon={<EditOutlined />} onClick={() => setVisible(true)} />
            </Tooltip>
            <Modal
                title="Редактирование свойства"
                visible={visible}
                onOk={handleSave}
                onCancel={handleCancel}
                okText="Сохранить"
                cancelText="Отмена"
                okButtonProps={{ disabled: editedText.trim() === '' }}
            >
                <Input.TextArea
                    value={editedText}
                    onChange={(e) => setEditedText(e.target.value)}
                    rows={4}
                />
            </Modal>
        </>
    );
};

export default React.memo(EditPropertyAction);
